//import { post, put } from "axios";
import axios from "axios";
import {
  getApiAsyn,
  baseUrl,
  getApiAsynWithBase,
  getApiAsynarrayBuffer,
  deleteApi,
  postApiAsynArrayBuffer,
} from "../../../PostAPI";
import { handleAPIError, APIError } from "../../../common/errorHandler";
import { API_URL } from "../../../../utils/constant";
import {
  extractData,
  formatDatesHyphan,
  getCurrentAndThreeDaysLater,
} from "../../../../utils";
import {
  decorateWithPaginationParamsPost,
  decorateWithSortParamsPost,
  getDecoratedUrl,
} from "../../../common/urlService";

export const getPayloadInfo = (obj, key) => {
  if (!obj || typeof obj !== "object") return undefined;
  return obj[key];
};

const { post, get } = axios;
export const fetchReservationsReservations1 = async (payload) => {
  console.log("ASDBKS", payload);
  const url = getDecoratedUrl({
    url: API_URL.RESERVATIONS_RESERVATIONS.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchReservationsReservations = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.RESERVATIONS_RESERVATIONS.GET,
    payload,
  });

  let sortdata = decorateWithSortParamsPost(payload);
  if (sortdata === "") {
    sortdata = "id,desc";
  }
  const { currentDate, threeDaysLater } = getCurrentAndThreeDaysLater();
  let startDate = formatDatesHyphan(
    getPayloadInfo(payload?.additinalFilter, "startDate") || currentDate
  );
  let endDate = formatDatesHyphan(
    getPayloadInfo(payload?.additinalFilter, "endDate") || threeDaysLater
  );

  let locationId = getPayloadInfo(payload?.additinalFilter, "location");
  let networkId = getPayloadInfo(payload?.additinalFilter, "network");
  let status = getPayloadInfo(payload?.additinalFilter, "status");
  let type = getPayloadInfo(payload?.additinalFilter, "type");
  let pageno = decorateWithPaginationParamsPost(payload);

  // Helper to check if value is empty (null, undefined, empty string, or empty array)
  const isEmpty = (val) => val === null || val === undefined || val === "" || (Array.isArray(val) && val.length === 0);

  // Extract column text filters from payload
  const columnFilters = payload?.filters || [];
  const getFilterValue = (filterKey) => {
    const filter = columnFilters.find(f => f.filterField === filterKey);
    return filter?.query || null;
  };

  let payloads = {
    paged: true,
    pageNumber: pageno?.pageNumber,
    pageSize: pageno?.pageSize,
    userId: localStorage.getItem("userId"),
    sort: sortdata,
    startDate: startDate,
    endDate: endDate,
    locationId: isEmpty(locationId) ? [0] : locationId,
    networkId: isEmpty(networkId) ? [0] : networkId,
    status: isEmpty(status) ? 0 : status,
    type: type ?? "pickupDate",
    // Text-based column filters
    filterRef: getFilterValue("ref"),
    filterNetworkTitle: getFilterValue("networkTitle"),
    filterLocationTitle: getFilterValue("locationTitle"),
    filterVehicle: getFilterValue("vehicle"),
    filterName: getFilterValue("name"),
    filterPaymentStatus: getFilterValue("paymentStatus"),
    filterRateType: getFilterValue("rateType"),
    filterBookingDate: getFilterValue("bookingDate"),
    filterPickup: getFilterValue("pickup"),
    filterDropoff: getFilterValue("dropoff"),
    filterDays: getFilterValue("days"),
    filterTotalAmount: getFilterValue("totalAmount"),
    filterCurrencyCode: getFilterValue("currencyCode"),
    filterStatus: getFilterValue("status"),
  };

  console.log('=== Reservation API Payload ===');
  console.log('Full payload:', JSON.stringify(payloads, null, 2));
  console.log('additinalFilter received:', JSON.stringify(payload?.additinalFilter, null, 2));

  try {
    let result = await dataUploadApi(
      `${url}`,
      payloads
    );
    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchReservationsReservationsDropdown = async (payload) => {
  const url = API_URL.RESERVATIONS_RESERVATIONS.DROPDOWN;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const multipartDataUploadImage = (url, payload) => {
  const formPayload = new FormData();
  formPayload.append("file", payload?.file[0]);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      authorization: localStorage.getItem("token"),
    },
  };
  return post(baseUrl + url, formPayload, config);
};

export const upladImageData = async (payload) => {
  const url = API_URL.UPLOAD_IMAGE.replace(":id", payload.id);
  try {
    let result = await multipartDataUploadImage(url, payload);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
const dataUploadApi = (url, data, isEdit = false) => {
  // const formPayload = new FormData();
  // // data part of multipart data
  // const json = JSON.stringify(data);
  // const blobData = new Blob([json], {
  //   type: 'application/json',
  // });
  // formPayload.append('data', blobData);

  // // file part of multipart data
  // files?.forEach((file) => {
  //   formPayload.append('file', file);
  // });

  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: localStorage.getItem("token"),
    },
  };

  if (isEdit) {
    return post(baseUrl + url, data, config);
  } else {
    return post(baseUrl + url, data, config);
  }
};
export const createReservationsReservations = async (payload) => {
  try {
    let result = await dataUploadApi(
      `${API_URL.RESERVATIONS_RESERVATIONS.CREATE}`,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const editReservationsReservations = async (payload) => {
  const url = API_URL.RESERVATIONS_RESERVATIONS.EDIT.replace(
    ":id",
    payload?.id
  );

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const getApi = (url) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: localStorage.getItem("token"),
    },
  };
  return get(baseUrl + url, config);
};

export const exportReservationsReservationsRecord = async (payload) => {
  const url = API_URL.RESERVATIONS_RESERVATIONS.EXPORT;
  // const url = getDecoratedUrl({
  //   url: API_URL.RESERVATIONS_RESERVATIONS.EXPORT,
  //   payload,
  // });
  let sortdata = decorateWithSortParamsPost(payload);
  if (sortdata === "") {
    sortdata = "id,desc";
  }
  const { currentDate, threeDaysLater } = getCurrentAndThreeDaysLater();
  let startDate = formatDatesHyphan(
    getPayloadInfo(payload?.additinalFilter, "startDate") || currentDate
  );
  let endDate = formatDatesHyphan(
    getPayloadInfo(payload?.additinalFilter, "endDate") || threeDaysLater
  );

  let locationId = getPayloadInfo(payload?.additinalFilter, "location");
  let networkId = getPayloadInfo(payload?.additinalFilter, "network");
  let status = getPayloadInfo(payload?.additinalFilter, "status");
  let type = getPayloadInfo(payload?.additinalFilter, "type");
  let pageno = decorateWithPaginationParamsPost(payload);

  let payloads = {
    paged: false, // For Excel export, get all records without pagination
    pageNumber: pageno?.pageNumber,
    pageSize: pageno?.pageSize,
    userId: localStorage.getItem("userId"),
    sort: sortdata,
    startDate: startDate,
    endDate: endDate,
    locationId: (locationId ?? "") === "" ? [0] : locationId,
    networkId: (networkId ?? "") === "" ? [0] : networkId,
    status: (status ?? "") === "" ? 0 : status,
    type: type ?? "pickupDate",
  };
  try {
    let result = await postApiAsynArrayBuffer(
      url,
      payloads,
      localStorage.getItem("token")
    );
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchReservationsReservationsById = async (payload) => {
  const url = API_URL.RESERVATIONS_RESERVATIONS.GET_BY_ID.replace(
    ":id",
    payload?.id
  );
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
export const deleteReservationsReservations = async (payload) => {
  try {
    const url = API_URL.RESERVATIONS_RESERVATIONS.DELETE.replace(
      ":id",
      payload?.id
    );

    let result = await deleteApi(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const searchReservationsReservations = async (payload) => {
  try {
    let result = await dataUploadApi(
      `${API_URL.RESERVATIONS_RESERVATIONS.SEARCH}`,
      payload
    );

    if (result?.data?.ERROR || result?.data?.error) {
      throw new APIError(result);
    }
    result = extractData(result, !payload?.filters);
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const sendConfirmationEmail = async (payload) => {
  const url = API_URL.RESERVATIONS_RESERVATIONS.SEND_CONFIRMATION_EMAIL.replace(
    ":id",
    payload?.reservationId
  );
  
  try {
    let result = await getApi(url);

    if (result?.error || result?.data?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const updateNoShow = async (payload) => {
  const url = API_URL.RESERVATIONS_RESERVATIONS.UPDATE_NO_SHOW;
  
  try {
    let result = await dataUploadApi(url, payload);

    if (result?.error || result?.data?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const syncToSofiac = async (payload) => {
  const url = `${baseUrl}${API_URL.RESERVATIONS_RESERVATIONS.SYNC_TO_SOFIAC}?reservation_id=${payload.reservationId}`;
  
  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: localStorage.getItem("token"),
      authName: payload.authName || "",
      authKey: payload.authKey || "",
    },
  };
  
  try {
    let result = await post(url, payload.data || {}, config);

    if (result?.error || result?.data?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchSofiacReservationStatus = async (payload) => {
  const url = `${API_URL.RESERVATIONS_RESERVATIONS.SOFIAC_STATUS}?reservation_id=${payload?.reservationId}`;

  try {
    let result = await getApiAsynWithBase(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
